module.exports = "https://static.wmbcdn.com/uniweb/images/c11781c689c05a27826146a354435fdf.svg";